interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPageChange }: Props) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  const btn =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40";

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className={`${btn} border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={`p-${p}`}
            type="button"
            onClick={() => onPageChange(p)}
            className={
              p === page
                ? `${btn} bg-primary-500 text-background-50`
                : `${btn} border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600`
            }
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${i}`} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className={`${btn} border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}